
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scanning",
      function () {
        return require("private-next-pages/scanning.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scanning"])
      });
    }
  